// === Enterprise Core Products ===
export const enterpriseProducts = [
  {
    id: 'data-governance',
    name: { zh: '智能数据治理平台', en: 'Smart Data Governance' },
    tagline: {
      zh: '企业级数据资产管理与治理一体化解决方案',
      en: 'Unified enterprise data governance and asset management',
    },
    desc: {
      zh: '覆盖数据资产管理、数据质量、血缘与元数据治理，支持接入外部数据开发引擎与自定义智能体，将存量开发任务和业务治理流程连接起来。提供私有化部署与 SaaS 租户服务。',
      en: 'Govern data assets, quality, lineage and metadata while integrating external development engines and custom agents into traceable workflows, with private deployment and SaaS tenant services.',
    },
    badge: { zh: '私有部署', en: 'Private Deploy' },
    accentColor: '#2563eb',
    features: {
      zh: ['数据资产管理', '数据质量监控', '血缘与元数据', '外部开发引擎接入', '自定义智能体', '私有化部署'],
      en: ['Data Assets', 'Data Quality', 'Lineage & Metadata', 'External Development Engines', 'Custom Agents', 'Private Deployment'],
    },
    links: [
      { label: { zh: '了解详情', en: 'Learn More' }, url: 'https://beiyidata.cn/dp', primary: true },
      { label: { zh: '申请演示', en: 'Request Demo' }, url: 'mailto:beibei@beiyidata.cn', primary: false },
    ],
  },
  {
    id: 'document-processing',
    name: { zh: '智能文档处理平台', en: 'Intelligent Document Processing' },
    tagline: { zh: '将非结构化资料转化为可信、可交付的业务数据', en: 'Turn enterprise documents into trusted, deliverable data' },
    desc: {
      zh: '面向 PDF、Word、Excel、扫描件与图片，贯通资料接入、分类归属、智能解析与提取、方案设计、批次执行、质量复核和数据交付。以原文证据和版本追溯支撑知识库、业务系统与 NEXA 决策应用。',
      en: 'Connect ingestion, classification, parsing, extraction, reusable plans, batch runs, quality review and delivery, with source evidence and version traceability for knowledge and decision applications.',
    },
    badge: { zh: '资料数据生产', en: 'Document-to-data' },
    accentColor: '#2563eb',
    features: {
      zh: ['多格式资料接入', '智能解析与提取', '可复用处理方案', '批次运行与监控', '质量门禁与人工复核', '证据追溯与数据交付'],
      en: ['Multi-format Ingestion', 'Parsing & Extraction', 'Reusable Plans', 'Batch Operations', 'Quality & Review', 'Evidence & Delivery'],
    },
    imageBase: '/images/document-processing/architecture',
    links: [
      { label: { zh: '申请演示', en: 'Request Demo' }, url: 'mailto:beibei@beiyidata.cn', primary: true },
    ],
  },
  {
    id: 'nexa',
    name: { zh: 'NEXA Decision OS', en: 'NEXA Decision OS' },
    tagline: {
      zh: '企业级智能分析决策执行操作系统',
      en: 'Enterprise intelligence, decision and execution operating system',
    },
    desc: {
      zh: '以企业本体统一对象、属性、关系、规则与动作，结合 GraphRAG、Agent 与 Action Engine，把企业 AI 从“会回答”推进到“能决策、能执行、可追溯”。',
      en: 'Unify enterprise objects, properties, relationships, rules and actions with Ontology, GraphRAG, Agent and Action Engine for governed, traceable decisions and execution.',
    },
    badge: { zh: '决策智能', en: 'Decision Intelligence' },
    accentColor: '#2563eb',
    features: {
      zh: ['企业本体建模', 'GraphRAG 证据组织', '受控 Agent 协作', 'Action 执行闭环', '全链路审计'],
      en: ['Enterprise Ontology', 'GraphRAG Evidence', 'Governed Agents', 'Action Loop', 'End-to-end Audit'],
    },
    links: [
      { label: { zh: '申请演示', en: 'Request Demo' }, url: 'mailto:beibei@beiyidata.cn', primary: true },
      { label: { zh: '联系我们', en: 'Contact Us' }, url: 'mailto:beibei@beiyidata.cn', primary: false },
    ],
  },
  {
    id: 'knowledge-base',
    name: { zh: '智能知识库', en: 'Enterprise Knowledge Base' },
    tagline: {
      zh: '构建企业专属知识图谱，赋能智能问答与业务决策',
      en: 'Build enterprise knowledge graphs for intelligent Q&A and decisions',
    },
    desc: {
      zh: '基于大语言模型的企业知识管理平台，支持多格式文档接入、语义检索与智能问答，私有化部署保障数据安全与合规。',
      en: 'LLM-powered enterprise knowledge management with multi-format document ingestion, semantic search and intelligent Q&A with private deployment.',
    },
    badge: { zh: '企业版', en: 'Enterprise' },
    accentColor: '#2563eb',
    features: {
      zh: ['多源文档接入', '语义检索', '智能问答', '知识图谱构建', '私有化部署'],
      en: ['Multi-source Docs', 'Semantic Search', 'Intelligent Q&A', 'Knowledge Graph', 'Private Deployment'],
    },
    links: [
      { label: { zh: '申请演示', en: 'Request Demo' }, url: 'mailto:beibei@beiyidata.cn', primary: true },
      { label: { zh: '联系我们', en: 'Contact Us' }, url: 'mailto:beibei@beiyidata.cn', primary: false },
    ],
  },
  {
    id: 'cdp',
    visible: false,
    name: { zh: 'CDP 客户数据平台', en: 'Customer Data Platform' },
    tagline: {
      zh: '整合全渠道数据，驱动精准营销与个性化体验',
      en: 'Unify cross-channel data for precise customer profiles and marketing',
    },
    desc: {
      zh: '统一多渠道客户数据，构建 360° 客户画像，支持标签体系管理、智能用户分群与营销自动化，助力数据驱动业务增长。',
      en: 'Unify multi-channel customer data to build 360° profiles with intelligent segmentation and marketing automation for data-driven growth.',
    },
    badge: { zh: '旗舰产品', en: 'Flagship' },
    accentColor: '#2563eb',
    features: {
      zh: ['全渠道数据整合', '客户 360° 画像', '标签体系管理', '智能用户分群', '营销自动化'],
      en: ['Omni-channel Data', '360° Profiles', 'Tag Management', 'Smart Segmentation', 'Marketing Automation'],
    },
    links: [
      { label: { zh: '申请演示', en: 'Request Demo' }, url: 'mailto:beibei@beiyidata.cn', primary: true },
      { label: { zh: '联系我们', en: 'Contact Us' }, url: 'mailto:beibei@beiyidata.cn', primary: false },
    ],
  },
]

// Keep temporarily unlisted products available for restoration without exposing them in public catalogs.
export const visibleEnterpriseProducts = enterpriseProducts.filter((product) => product.visible !== false)
export const consumerAppsVisible = false

// === Consumer Apps (kept but de-emphasized) ===
export const consumerProducts = [
  {
    id: 'beibei-budget',
    name: { zh: '贝贝记账', en: 'Beibei Budget' },
    tagline: { zh: '简单好用的个人与家庭记账工具', en: 'Simple personal and family budgeting' },
    desc: {
      zh: '支持语音记账、账单导入、AI 财务分析与预算跟踪。',
      en: 'Voice logging, bill import, AI financial analysis and budget tracking.',
    },
    badge: { zh: 'iOS · 免费', en: 'iOS · Free' },
    accentColor: '#60a5fa',
    links: [
      { label: { zh: 'App Store', en: 'App Store' }, url: 'https://apps.apple.com/us/app/%E8%B4%9D%E8%B4%9D%E8%AE%B0%E8%B4%A6/id6755133153', primary: true },
    ],
  },
  {
    id: 'pagepilot',
    name: { zh: 'PagePilot', en: 'PagePilot' },
    tagline: { zh: '更轻更快的 AI 浏览器助手', en: 'Lightweight AI browser assistant' },
    desc: {
      zh: '支持网页问答、划词解释、整页总结与翻译。',
      en: 'Page Q&A, highlight explainers, full-page summaries and translation.',
    },
    badge: { zh: 'Chrome 扩展', en: 'Chrome Extension' },
    accentColor: '#e8c96a',
    links: [
      { label: { zh: '获取扩展', en: 'Get Extension' }, url: 'https://beiyidata.cn/pagepilot', primary: true },
    ],
  },
]

// === Legacy categories format (used by AppFooter) ===
export const categories = [
  {
    id: 'enterprise',
    label: { zh: '企业产品', en: 'Enterprise' },
    desc: { zh: '面向企业的数据智能核心产品', en: 'Core intelligent data products for enterprises' },
    accent: 'blue',
    products: visibleEnterpriseProducts,
  },
  {
    id: 'consumer',
    label: { zh: '个人应用', en: 'Consumer Apps' },
    desc: { zh: '面向个人用户的移动应用', en: 'Mobile apps for individual users' },
    accent: 'amber',
    products: consumerProducts,
  },
].filter((category) => category.id !== 'consumer' || consumerAppsVisible)

// ====== LEGACY - kept for reference only, not used in UI ======
const _legacyCategories = [
  {
    id: 'ai-tools',
    label: { zh: 'AI 工具', en: 'AI Tools' },
    desc: { zh: '面向开发者与效率用户的 AI 工具。', en: 'AI tools for developers and power users.' },
    accent: 'amber',
    products: [
      {
        id: 'pagepilot',
        name: 'PagePilot',
        tagline: {
          zh: '更轻更快的 AI 浏览器助手，价格仅主流方案约 1/10。',
          en: 'A lightweight AI browser assistant at around 1/10 mainstream pricing.',
          es: 'Asistente de navegador con IA, ligero y rápido, por ~1/10 del precio habitual.',
          fr: "Assistant navigateur IA léger et rapide, à ~1/10 du prix des solutions courantes.",
          ja: '軽量で高速なAIブラウザアシスタント。主要サービスの約1/10価格。',
        },
        desc: {
          zh: '支持网页问答、划词解释、整页总结、翻译与智能阅读，适合高频信息处理场景。',
          en: 'Supports page Q&A, highlight explainers, full-page summaries, translation, and smart reading.',
          es: 'Incluye preguntas sobre páginas, explicación de texto resaltado, resúmenes, traducción y lectura inteligente.',
          fr: 'Inclut Q&A sur page web, explication de sélection, résumé complet, traduction et lecture intelligente.',
          ja: 'ページQ&A、選択テキスト解説、全文要約、翻訳、スマートリーディングに対応。',
        },
        badge: {
          zh: 'Chrome 扩展',
          en: 'Chrome Extension',
          es: 'Extensión de Chrome',
          fr: 'Extension Chrome',
          ja: 'Chrome拡張',
        },
        coverType: 'gradient',
        coverGradient: 'from-[#0f1a2e] to-[#1a2a1a]',
        accentColor: '#e8c96a',
        features: {
          zh: ['网页问答', '智能填表', '整页总结', '智能翻译'],
          en: ['Page Q&A', 'Smart autofill', 'Full-page summary', 'AI translation'],
          es: ['Q&A de página', 'Autocompletar inteligente', 'Resumen completo', 'Traducción IA'],
          fr: ['Q&A de page', 'Auto-remplissage intelligent', 'Résumé complet', 'Traduction IA'],
          ja: ['ページQ&A', 'スマート入力補完', '全文要約', 'AI翻訳'],
        },
        links: [
          {
            label: {
              zh: '获取扩展',
              en: 'Get Extension',
              es: 'Instalar extensión',
              fr: "Installer l'extension",
              ja: '拡張機能を入手',
            },
            url: 'https://beiyidata.cn/pagepilot',
            primary: true,
          },
        ],
      },
    ],
  },
  {
    id: 'consumer',
    label: {
      zh: '消费者应用',
      en: 'Consumer Apps',
      es: 'Apps de Consumo',
      fr: 'Applications Grand Public',
      ja: 'コンシューマー向けアプリ',
    },
    desc: {
      zh: '面向日常生活的移动应用，强调体验与长期使用。',
      en: 'Mobile apps for daily life, designed for long-term use.',
      es: 'Aplicaciones móviles para la vida diaria, diseñadas para uso continuo.',
      fr: 'Applications mobiles du quotidien, conçues pour un usage durable.',
      ja: '日常生活向けのモバイルアプリ。長期利用を重視。',
    },
    accent: 'blue',
    products: [
      {
        id: 'beibei-budget',
        name: 'Beibei Budget',
        nameZh: '贝贝记账',
        tagline: {
          zh: '简单好用的个人与家庭记账工具。',
          en: 'Simple personal and family budgeting.',
          es: 'Finanzas personales y familiares, simples.',
          fr: 'Gestion budgétaire personnelle et familiale simplifiée.',
          ja: '個人・家計向けのシンプルな家計簿アプリ。',
        },
        desc: {
          zh: '支持语音记账、账单导入、AI 财务分析、共享账本与预算跟踪。',
          en: 'Includes voice logging, bill import, AI analysis, shared ledgers, and budget tracking.',
          es: 'Incluye registro por voz, importación de facturas, análisis IA y presupuesto compartido.',
          fr: "Inclut saisie vocale, import de relevés, analyse IA et suivi budgétaire partagé.",
          ja: '音声記帳、明細インポート、AI分析、共有台帳、予算トラッキングに対応。',
        },
        badge: {
          zh: 'iOS · 免费',
          en: 'iOS · Free',
          es: 'iOS · Gratis',
          fr: 'iOS · Gratuit',
          ja: 'iOS・無料',
        },
        coverType: 'image',
        coverUrl:
          'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/a7/f2/18/a7f21889-1d36-16fa-9350-a640e33cf5d9/Placeholder.mill/1200x630wa.jpg',
        accentColor: '#60a5fa',
        officialUrl: 'https://beiyidata.cn/beibeibudget',
        links: [
          {
            label: {
              zh: 'App Store',
              en: 'App Store',
              es: 'App Store',
              fr: 'App Store',
              ja: 'App Store',
            },
            url: 'https://apps.apple.com/us/app/%E8%B4%9D%E8%B4%9D%E8%AE%B0%E8%B4%A6/id6755133153',
            primary: true,
          },
          {
            label: {
              zh: '官网',
              en: 'Website',
              es: 'Sitio web',
              fr: 'Site web',
              ja: '公式サイト',
            },
            url: 'https://beiyidata.cn/beibeibudget',
            primary: false,
          },
        ],
      },
      {
        id: 'nomi',
        name: 'Nomi',
        tagline: {
          zh: '先理解你的状态，再陪你安排任务节奏。',
          en: 'Reads your state first, then supports your rhythm.',
          es: 'Primero entiende tu estado, luego te ayuda con tu ritmo.',
          fr: "Comprend d'abord votre état, puis accompagne votre rythme.",
          ja: 'まず状態を理解し、その上でタスクのリズムを支援。',
        },
        desc: {
          zh: '关注情绪、能量与任务压力，提供更贴合当下状态的支持建议。',
          en: 'Tracks mood, energy, and task pressure to provide context-aware support.',
          es: 'Monitorea ánimo, energía y presión de tareas para ofrecer apoyo contextual.',
          fr: "Suit l'humeur, l'énergie et la pression pour proposer un accompagnement contextualisé.",
          ja: '気分・エネルギー・タスク負荷を捉え、状況に合うサポートを提供。',
        },
        badge: {
          zh: 'iOS · 免费',
          en: 'iOS · Free',
          es: 'iOS · Gratis',
          fr: 'iOS · Gratuit',
          ja: 'iOS・無料',
        },
        coverType: 'image',
        coverUrl:
          'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/cb/5c/aa/cb5caa84-9953-a57e-15b1-98d6346f05fa/Placeholder.mill/1200x630wa.jpg',
        accentColor: '#60a5fa',
        officialUrl: 'https://beiyidata.cn/nomi',
        links: [
          {
            label: {
              zh: 'App Store',
              en: 'App Store',
              es: 'App Store',
              fr: 'App Store',
              ja: 'App Store',
            },
            url: 'https://apps.apple.com/us/app/nomi/id6761092206',
            primary: true,
          },
          {
            label: {
              zh: '官网',
              en: 'Website',
              es: 'Sitio web',
              fr: 'Site web',
              ja: '公式サイト',
            },
            url: 'https://beiyidata.cn/nomi',
            primary: false,
          },
        ],
      },
    ],
  },
]
export { _legacyCategories }
